(() => {
  'use strict';

  const root = document.documentElement;
  const storageKey = '58g-intro-seen-v1';
  const force = new URLSearchParams(window.location.search).get('intro') === '1';
  const intro = document.querySelector('[data-fg-site-intro]');
  const visualViewport = window.visualViewport;
  let finished = false;

  const centerIntro = () => {
    if (!intro) return;
    const left = (visualViewport?.offsetLeft || 0) + (visualViewport?.width || window.innerWidth) / 2;
    const top = (visualViewport?.offsetTop || 0) + (visualViewport?.height || window.innerHeight) / 2;
    intro.style.setProperty('--fg-intro-center-x', `${left}px`);
    intro.style.setProperty('--fg-intro-center-y', `${top}px`);
  };

  const announceComplete = (animated) => {
    window.dispatchEvent(new CustomEvent('58g:intro-complete', {
      detail: { animated, completedAt: performance.now() }
    }));
  };

  if (!intro || root.classList.contains('fg-intro-skip')) {
    announceComplete(false);
    return;
  }

  const markSeen = () => {
    try {
      window.localStorage.setItem(storageKey, '1');
    } catch (_) {
      // The animation still completes if browser storage is unavailable.
    }
  };

  const finish = () => {
    if (finished) return;
    finished = true;
    window.clearTimeout(window.fgIntroHardFallback);
    visualViewport?.removeEventListener('resize', centerIntro);
    visualViewport?.removeEventListener('scroll', centerIntro);
    window.removeEventListener('resize', centerIntro);
    root.classList.remove('fg-intro-pending', 'fg-intro-play');
    root.classList.add('fg-intro-done');
    markSeen();
    announceComplete(true);
  };

  if (force) {
    root.classList.remove('fg-intro-skip', 'fg-intro-done');
    root.classList.add('fg-intro-pending');
  }

  centerIntro();
  visualViewport?.addEventListener('resize', centerIntro, { passive: true });
  visualViewport?.addEventListener('scroll', centerIntro, { passive: true });
  window.addEventListener('resize', centerIntro, { passive: true });

  const start = () => {
    if (!finished) root.classList.add('fg-intro-play');
  };

  requestAnimationFrame(() => requestAnimationFrame(start));
  window.setTimeout(start, 120);

  window.setTimeout(finish, 2900);
})();
